module.exports = __webpack_public_path__ + "static/img/banner-3.81b25ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-3.jpg
// module id = ctal
// module chunks = 7